<template>
  <div class="dataPresentationSmall-container">
    <h2>{{ title }}</h2>
    <div class="parameter">
      <p><count-to
          :startVal='startVal'
          :endVal='number'
          :duration='duration'
        ></count-to></p>
      <span class="unit">双</span>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';

export default {
  name: 'DataPresentationSmall',
  props: {
    title: String,
    number: Number
  },
  components: {
    CountTo
  },
  data () {
    return {
      startVal: 0,
      duration: 1000
    }
  },
  watch: {
    'number': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.startVal = oldVal
        setTimeout(() => { this.duration = 20 * 1000 }, 1000)
      }
    },
  }
}
</script>

<style scoped>
.dataPresentationSmall-container {}

.parameter {
  display: flex;
  align-items: flex-end;
}

h2 {
  font-size: 20px;
  text-align: left;
  line-height: 25px;
}

p {
  color: rgb(239, 176, 64);
  font-size: 67px;
  font-weight: bold;
  text-shadow: 2px 2px 5px red;
}

.unit {
  font-weight: bold;
  font-size: 20px;
  padding-bottom: 7px;
  margin-left: 5px;
}
</style>
